type Props = {
  name: string;
};

export const Title: React.FC<Props> = ({ name }) => {
  return <h4 className="mb-0">{name}</h4>;
};
